module.exports = __webpack_public_path__ + "img/poster_id_cb.9709fd02.png";